// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uYC0","type":"styles_type__3CDOV","choices":"styles_choices__3oMYG"};